module.exports = __webpack_public_path__ + "media/images/dish-3-6644b6f23e2e94f032a84d21a5012188.webp";